import { REACT_APP_API_URL } from '../../setup/config';
import axios, { handleApiError } from '../axios';

export const searchVendorPayments = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/vendor-payment/search`, data);
        return await response.data;
    } catch (error) {
        console.log("searchVendorPayments - error", error)
        return handleApiError(error)
    }
}

export const searchSellerPOVendorPayments = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/vendor-payment/searchSellerPO`, data);
        console.log("searchSellerPOVendorPayments-res", response)
        return await response.data;
    } catch (error) {
        console.log("searchSellerPOVendorPayments - error", error)
        return handleApiError(error)
    }
}

export const getVendorPaymentById = async (vendorPaymentId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/vendor-payment/${vendorPaymentId}`);
        return await response.data;
    } catch (error) {
        console.log("getVendorPaymentById - error", error)
        return handleApiError(error)
    }
}

export const getVendorPaymentBySellerPOId = async (sellerPOId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/vendor-payment/sellerpo/${sellerPOId}`)
        return await response.data
    } catch (error) {
        console.log("getVendorPaymentBySellerPOId - error", error)
        return handleApiError(error)
    }
}

export const insertVendorPayment = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/vendor-payment/create`, data);
        return await response.data;
    } catch (error) {
        console.log("insertVendorPayment - error", error)
        return handleApiError(error)
    }
}

export const getVendorPayments = async () => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/vendor-payment/get/all-vendor-payments`);
        return await response.data;
    } catch (error) {
        console.log("getAllVendorPayment - error", error)
        return handleApiError(error)
    }
}

export const approveVendorPaymentsStatus = async (vendorPaymentId, data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/vendor-payment/approve/${vendorPaymentId}`, data);
        return await response.data;
    } catch (error) {
        console.log("approveVendorPaymentsStatus - error", error)
        return handleApiError(error)
    }
}

export const rejectVendorPaymentsStatus = async (vendorPaymentId, data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/vendor-payment/reject/${vendorPaymentId}`, data);
        return await response.data;
    } catch (error) {
        console.log("rejectVendorPaymentsStatus - error", error)
        return handleApiError(error)
    }
}

export const cancelVendorPaymentsStatus = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/vendor-payment/cancel-status`, data);
        return await response.data;
    } catch (error) {
        console.log("cancelVendorPaymentsStatus - error", error)
        return handleApiError(error)
    }
}

export const verifyVendorPaymentByFinance = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/vendor-payment/verify`, data);
        return await response.data;
    } catch (error) {
        console.log("verifyVendorPaymentByFinance - error", error)
        return handleApiError(error)
    }
}

export const includeInBudget = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/vendor-payment/include-budget`, data);
        return await response.data;
    } catch (error) {
        console.log("includeInBudget - error", error)
        return handleApiError(error)
    }
}

export const updateVendorPaymentsStatus = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/vendor-payment/status`, data);
        return await response.data;
    } catch (error) {
        console.log("updateVendorPaymentsStatus - error", error)
        return handleApiError(error)
    }
}

export const updateVendorPaymentsStatusAndCheque = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/vendor-payment/status-cheque`, data)
        return await response.data;
    } catch (error) {
        console.log("updateVendorPaymentsStatusAndCheque - error", error)
        return handleApiError(error)
    }
}

export const getPayableAmount = async (data) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/vendor-payment/payable-amount`, data)
        return await response.data;
    } catch (error) {
        console.log("getPayableAmount - error", error)
        return handleApiError(error)
    }
}

export const getVendorPaymentByDocNo = async (docNo) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/vendor-payment/get-vendor-payment-by-doc-no/${docNo}`);
        return await response.data;
    } catch (error) {
        console.log("getVendorPaymentByDocNo - error", error)
        return handleApiError(error)
    }
}


export const getVendorPaymentTracker = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/vendor-payment/daily/payment-tracker`, data)
        return await response.data
    } catch (error) {
        console.log("getVendorPaymentTracker - error", error)
        return handleApiError(error)
    }
}

export const updateVendorPaymentUTR = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/vendor-payment/update/utr`, data)
        return await response.data
    } catch (error) {
        console.log("updateVendorPaymentUTR - error", error)
        return handleApiError(error)
    }
}